import api from "src/api/axios";

const createRoute = async (input) => {
  return api.post(`/routes`, input).then((result) => {
    return result.data;
  });
};

const createBulkRoute = async (input) => {
  return api.post(`/routes/bulk-create`, input).then((result) => {
    return result.data;
  });
};

const updateRoute = async (input, id) => {
  return api.patch(`/routes/${id}`, input).then((result) => {
    return result.data;
  });
};

const updateActiveStatus = async (input, id) => {
  return api.patch(`/routes/active-inactive/${id}`, input).then((result) => {
    return result.data;
  });
};

const getRouteList = async ({
  limit,
  page,
  searchString,
  tripUrgency,
  routeType,
  country,
}) => {
  const params = new URLSearchParams({
    page: page ? page : "1",
    limit: limit ? limit : "10",
  });
  if (searchString) params.append("name", searchString);
  if (country) params.append("country", country);
  if (tripUrgency) params.append("tripUrgency", tripUrgency);
  if (routeType) params.append("routeType", routeType);
  return api.get(`/routes?${params}`).then((result) => {
    return result.data;
  });
};

const getSearchAbleRoutes = async ({ searchString, country }) => {
  const params = new URLSearchParams();
  if (searchString) params.append("name", searchString);
  if (country) params.append("country", country);
  return api.get(`/routes/list?${params}`).then((result) => {
    return result.data;
  });
};

const getSingleRoute = async (id) => {
  return api.get(`/routes/${id}`).then((result) => {
    return result.data;
  });
};

export {
  createRoute,
  getRouteList,
  getSingleRoute,
  updateRoute,
  updateActiveStatus,
  createBulkRoute,
  getSearchAbleRoutes,
};
